import React from "react"
import {
  AchievedIcon,
  ActiveIcon,
  AddIconWrapper,
  MissedIcon,
  OpportunityDetailTooltip,
  WatchIcon,
} from "./Atom"

import { Box, Typography } from "@mui/material"
import { useDispatch } from "react-redux"
import {
  setMetricOpportunityActiveRow,
  setMetricOpportunityDetail,
  setMetricOpportunityModalOpen,
} from "../../redux/slices/metricSlice"

import { toast } from "react-toastify"
import MetricOpportunityDetail from "../Tooltip/MetricOpportunityDetail"
import { getTokenLocal } from "../../../helper/utils"
import MetricAPI from "../../../api/metric"
import { useResponseHandle } from "../../hooks"
import { useNavigate } from "react-router-dom"
import { permissions } from "../../../config/constants"
import { useSelector } from "react-redux"

const metricAPI = new MetricAPI()

const OpportunityAddIcon = (props: any) => {
  const navigate = useNavigate()

  const { row } = props

  const dispatch = useDispatch()

  const token: any = getTokenLocal()

  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })

  const fetchOpportunityInfo = async (opportunityId: any) => {
    const response: any = await metricAPI.getOpportunity(token, opportunityId)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch(setMetricOpportunityDetail(response?.data?.data))
      }
    } else {
      navigate("/auth")
    }

    return result
  }

  const handleAddIconClick = () => {
    if (
      row?.original?.storeData == null ||
      row?.original?.storeData?.length == 0
    ) {
      toast.info("No metric KPI!")
      return
    }

    if (!allPerms.includes(permissions?.METRICS_CREATE_OPPORTUNITY)) {
      return
    }

    if (row?.original?.opportunity_status !== "active") {
      dispatch(setMetricOpportunityModalOpen(true))
      dispatch(setMetricOpportunityActiveRow(row))
    }
  }

  return (
    <Box sx={{ margin: "0", padding: "0" }}>
      {row?.original?.opportunity_status ? (
        <OpportunityDetailTooltip
          title={<MetricOpportunityDetail />}
          arrow
          placement="right"
          followCursor={true}
        >
          <AddIconWrapper
            // sx={{ cursor: row?.original?.opportunity_status !== "active" ? "pointer" : "" }}
            onClick={() => handleAddIconClick()}
            sx={{ cursor: "pointer" }}
            onMouseEnter={() => {
              fetchOpportunityInfo(row.original.opportunity_id)
            }}
          >
            {row?.original?.opportunity_status === "active" ? (
              <ActiveIcon />
            ) : row?.original?.opportunity_status === "missed" ? (
              <MissedIcon />
            ) : row?.original?.opportunity_status === "achieved" ? (
              <AchievedIcon />
            ) : null}
          </AddIconWrapper>
        </OpportunityDetailTooltip>
      ) : (
        <AddIconWrapper
          sx={{ cursor: "pointer" }}
          onClick={() => handleAddIconClick()}
        ></AddIconWrapper>
      )}
    </Box>
  )
}

export default OpportunityAddIcon
